export default __webpack_public_path__ + "static/media/79.efed5f12.jpg";